<template>
  <div class="Withdrawal">
    <el-row :gutter="20" style="padding-bottom: 10px;" v-if="chaoguan">
      <el-col :span="3" label="" style="display: flex;flex-direction: row;align-items:center;">
        <span style="font-size:14px;width:110px;padding-right:10px">商户名称</span>
        <el-select v-model="suoshudianzhan" placeholder="请选择清分人" @change="change_value" filterable clearable
          @clear="publicMethods">
          <el-option v-for="item in powerStationList" :key="item.id" :label="item.merchantName" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="center" v-if="!chaoguan">
      <h4 style="display: flex;justify-content: space-between;">
        <span>平台线上结算业务</span>
        <div class="rights">
          <el-button type="info" @click="UserMessage">用户信息</el-button>
          <el-button type="warning" @click="moneyMethods">定时提现</el-button>
          <el-button type="success" @click="chu(1)">导出入账明细</el-button>
          <el-button type="danger" @click="chu(0)">导出出账明细</el-button>
        </div>
      </h4>
      <div class="ceil">
        <li>
          <dl>
            <dt>{{ jis(listobj.money, listobj.freezeMoney, 100, 2) }}</dt>
            <dd>账户余额（元）</dd>
          </dl>
          <dl>
            <dt>{{ jisuan(listobj.toBeCreditedMoney, 100, 2) }}</dt>
            <dd>待入账金额（元）</dd>
          </dl>
          <dl>
            <dt>{{ jisuan(listobj.freezeMoney, 100, 2) }}</dt>
            <dd>冻结金额（元）</dd>
          </dl>
          <dl v-if="bianji">
            <dt>提现方式</dt>
            <dd style="color: #1989FA;">人工转账</dd>
            <!-- <dd style="color: #1989FA;">设置提现方式</dd> -->
          </dl>
          <!-- v-if="bianji" -->
          <dl style=" display: flex;flex-direction: column;">
            <button @click="ruzhang1(0)"
              style="background-color: #1989FA;color: #fff;border: none;border-radius: 15px;">入账明细</button>
            <button style="background-color: orange;color:#fff;margin-top: 10px;border: none;border-radius: 15px;"
              @click="ruzhang1(1)">提现明细</button>
          </dl>
          <dl style=" display: flex;flex-direction: column;">
            <button @click="tixianMethods"
              style="background-color: #1989FA;color: #fff;border: none;border-radius: 15px;">提现</button>
            <button style="background-color: orange;color:#fff;margin-top: 10px;border: none;border-radius: 15px;"
              @click="agoMoney">原入账记录</button>
          </dl>
        </li>
        <li>
          <dl>
            <dt>本月实际入账</dt>
            <dd>
              <span>{{ jisuan(listobj.postingMonthTotalMoney, 100, 2) }}</span>
              <span @click="ruzhangs(0)">本月充电收入（元）></span>
            </dd>
          </dl>
          <dl>
            <dt>上月实际入账</dt>
            <dd>
              <span>{{ jisuan(listobj.postingLastMonthTotalMoney, 100, 2) }}</span>
              <span @click="ruzhangs(1)">上月充电收入（元）></span>
            </dd>
          </dl>
          <dl>
            <dt>本月实际出账</dt>
            <dd>
              <span>{{ jisuan(listobj.withdrawalMonthTotalMoney, 100, 2) }}</span>
              <span @click="mingxis(0)">本月账户出账（元）></span>
            </dd>
          </dl>
          <dl>
            <dt>上月实际出账</dt>
            <dd>
              <span>{{ jisuan(listobj.withdrawalLastMonthTotalMoney, 100, 2) }}</span>
              <span @click="mingxis(1)">上月账户出账（元）></span>
            </dd>
          </dl>
        </li>
      </div>
    </div>
    <!-- 定时提现 -->
    <el-dialog :visible.sync="tixianDialoag" title="定时提现" width="40%" append-to-body @close="closeMethods3">
      <div class="centerList">
        <iframe :src="embeddedUrl" class="embedded-frame" frameborder="0" scrolling="auto">
        </iframe>
      </div>
    </el-dialog>
    <el-card v-if="chaoguan">
      <li style="margin-bottom: 10px;display: flex;justify-content: flex-end;margin-top: -10px;">
        <el-button type="primary" icon="el-icon-download" @click="OrderMethods">导出</el-button>
      </li>
      <el-table :data="ListTil" border>
        <el-table-column label="商户名称" prop="merchantName" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span>
              {{ scope.row.merchantName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="真实姓名" prop="trueName">
          <template slot-scope="scope">
            <span>
              {{ scope.row.trueName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号" prop="phone" width="110">
          <template slot-scope="scope">
            <span>
              {{ scope.row.phone }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="待转入金额" prop="toBeCreditedMoney" width="94">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.toBeCreditedMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="冻结金额" prop="freezeMoney" width="90">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.freezeMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="账户余额" prop="money" width="120">
          <template slot-scope="scope">
            <span style="color:red">
              ￥ {{ jis(scope.row.money, scope.row.freezeMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="提现方式" prop="withdrawalType" width="90">
          <template slot-scope="scope">
            <span>
              {{ scope.row.withdrawalType == 0 ? '人工转账' : '自动转账' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="status" width="60">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
              :active-color="scope.row.status == 0 ? '#13ce66' : '#ff4949'"
              :inactive-color="scope.row.status == 0 ? '#13ce66' : '#ff4949'"
              @change="changeMethods(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间" prop="updateTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.updateTime !== '' ? scope.row.updateTime : '---' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="368" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="editMethods(scope.row)"
              v-if="bianji">编辑</el-button>
            <el-button size="mini" type="warning" @click="ruzhang(scope.row)">入账明细</el-button>
            <el-button size="mini" type="warning" @click="mingxi(scope.row)">提现明细</el-button>
            <el-button size="mini" icon="el-icon-s-help" type="danger" @click="dongjie(scope.row)"
              v-if="stopMoney">冻结</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[6, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
    <!-- 清分明细弹窗 -->
    <el-dialog :visible.sync="titleDialoag2" :title="chaoguan ? title : ds + title" width="80%" append-to-body
      @close="colseDialoag2">
      <div class="listnames" v-if="tabList.length > 0">
        <div v-for="(item, index) in listname" :key="index" class="dl">
          <p>{{ item.name }}</p>
          <p>￥{{ jisuan(item.money, 100, 2) }}</p>
        </div>
      </div>
      <el-table :data="tabList" border>
        <el-table-column align="center" label="姓名" prop="merchantMame">
          <template slot-scope="scope">
            <span>
              {{ scope.row.merchantMame }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="title == '清分提现明细' ? '提现状态' : '清分类型'" prop="type" width="90">
          <template slot-scope="scope">
            <span>
              {{ scope.row.type == 0 ? '提现成功' : scope.row.type == 1 ? '入账' : scope.row.type == 2 ? '补差' : '提现失败' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分比例" prop="sortingRatio" v-if="title !== '清分提现明细'" width="90">
          <template slot-scope="scope">
            <span>
              {{ scope.row.sortingRatio + '%' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" v-if="title !== '清分提现明细'" label="清分金额" prop="toBeCreditedMoney" width="90">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.commissionMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" v-if="title !== '清分提现明细'" label="清分金额" prop="toBeCreditedMoney">
            <template slot-scope="scope">
              <span >
                ￥{{ jisuan(scope.row.toBeCreditedMoney, 100, 2) }}
              </span>
            </template>
          </el-table-column> -->
        <el-table-column align="center" v-if="title == '清分提现明细'" label="申请提现金额" prop="changeMoney" width="110">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.changeMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" v-if="title !== '清分提现明细'" label="订单总金额" prop="orderMoney" width="100">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.orderMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" v-if="title == '清分提现明细'" label="提现手续费" prop="withdrawalServiceMoney"
          width="100">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.withdrawalServiceMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <!-- changeMoney -->
        <el-table-column align="center" v-if="title !== '清分提现明细'" label="入账金额" prop="postingTotalMoney" width="90">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.changeMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" v-if="title == '清分提现明细'" label="应到账金额" prop="realityMoney" width="100">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.realityMoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="title == '清分提现明细' ? '收款账户 ' : '入账商户'" prop="trueName"
          width="120"></el-table-column>
        <el-table-column align="center" :label="title == '清分提现明细' ? '提现单号 ' : '流水单号'" prop="billCode"></el-table-column>
        <el-table-column align="center" label="电费/服务费" prop="merchantName" v-if="title !== '清分提现明细'" width="180">
          <template slot-scope="scope">
            <span>
              ￥{{ jisuan(scope.row.orderMoney - scope.row.servicemoney, 100, 2) }}
            </span>
            <span>
              |
            </span>
            <span>
              ￥{{ jisuan(scope.row.servicemoney, 100, 2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="提现类型" prop="withdrawalType" v-if="title == '清分提现明细'" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.withdrawalType == 0 ? '人工到账' : '自动到账' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="title == '清分提现明细' ? '操作人' : '备注'" prop="des" width="120">
          <template slot-scope="scope">
            <span>
              {{ title == '清分提现明细' ? scope.row.adminName : scope.row.des }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="title == '清分提现明细' ? '提现时间 ' : '入账时间'" prop="createTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.createTime !== null ? scope.row.createTime : '---' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
        :current-page="carinfo.page" :page-sizes="[8, 20, 50, 100]" :page-size="carinfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total2" background>
      </el-pagination>
    </el-dialog>
    <!-- 入账、提现明细 -->
    <el-dialog :title="title1" :visible.sync="ruzhang1Dialoag" width="80%" @close="ruzhang1Methods" append-to-body>
      <!-- 内容主体区域 -->
      <el-table :data="ruzhangList" border empty-text="暂无数据">
        <el-table-column align="center" label="商户名称" prop="trueName">
          <template slot-scope="scope">
            <span>
              {{ scope.row.trueName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="初始金额" prop="startMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.startMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="变动金额" prop="changeMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.changeMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="余额" prop="newMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.newMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结算类型" prop="type" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.type == 0 ? 'danger' : scope.row.type == 1 ? 'success' : scope.row.type == 2 ? 'warning' : ''">{{
      scope.row.type == 0 ? '提现' : scope.row.type == 1 ? '入账' : scope.row.type == 2 ? '补差' : '提现失败' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="流水单号" prop="billCode" width="260">
          <template slot-scope="scope">
            <span>
              {{ scope.row.billCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务费" prop="servicemoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.servicemoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="订单金额" prop="orderMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.orderMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="des">
          <template slot-scope="scope">
            <span>{{ scope.row.des }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="入账时间" prop="createTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.createTime }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination @size-change="mingxiChange" @current-change="mingxiCurrentChange" :current-page="mingxiInfo.page"
        :page-sizes="[8, 20, 50, 100]" :page-size="mingxiInfo.limit" layout="total, sizes, prev, pager, next, jumper"
        :total="mingxiTotal" background>
      </el-pagination>
    </el-dialog>
    <!-- 原入账记录 账单明细的对话框 -->
    <el-dialog title="账单明细" :visible.sync="expendDialogVisible" width="80%" @close="expendDialogClosed" append-to-body>
      <!-- 内容主体区域 -->
      <el-table :data="expendList" border empty-text="暂无数据">
        <el-table-column align="center" label="商户名称" prop="adminName">
          <template slot-scope="scope">
            <span>
              {{ scope.row.adminName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="初始金额" prop="startMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.startMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="变动金额" prop="changeMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.changeMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="余额" prop="newMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.newMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结算类型" prop="type" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.type == 0 ? 'danger' : scope.row.type == 1 ? 'success' : scope.row.type == 2 ? 'warning' : ''">{{
      scope.row.type == 0 ? '提现' : scope.row.type == 1 ? '入账' : scope.row.type == 2 ? '补差' : '提现失败' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="流水单号" prop="billCode" width="260">
          <template slot-scope="scope">
            <span>
              {{ scope.row.billCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务费" prop="servicemoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.servicemoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="订单金额" prop="orderMoney" width="120">
          <template slot-scope="scope">
            <span>￥{{ jisuan(scope.row.orderMoney, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="des">
          <template slot-scope="scope">
            <span>{{ scope.row.des }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="入账时间" prop="createTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.createTime }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination @size-change="zhangdanChange" @current-change="zhangdanCurrentChange"
        :current-page="zhangdanInfo.page" :page-sizes="[8, 20, 50, 100]" :page-size="zhangdanInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="expendTotal" background>
      </el-pagination>
    </el-dialog>
    <!-- 冻结金额 -->
    <el-dialog title="冻结金额" :visible.sync="coolDialoag" width="35%">
      <div class="cool">
        <p>
          <span>￥</span>
          <el-input v-model="freezeMoney" style="width:50%"></el-input>
        </p>
        <p>--温馨提示--</p>
        <p>1、冻结金额为0，则不冻结金额;</p>
        <p>
          2、填写金额多少则冻结多少，冻结金额不支持提现。
        </p>
        <p>
          <button @click="falseMethods">取消</button>
          <button v-debounce="okMethods">确定</button>
        </p>
      </div>
    </el-dialog>
    <el-dialog title="编辑清分人" :visible.sync="editDialogVisible" width="40%" @close="editDialogClosed" append-to-body
      :close-on-click-modal="false">
      <el-form :model="vinAccountForm" :rules="vinAccountFormRules" ref="vinAccountFormRef" label-width="80px">
        <el-row type="flex" class="row-bg" justify="space-around" :gutter="24">
          <el-col :span="12">
            <!-- 内容主体区域 -->
            <el-form-item label="提现商户" prop="adminId">
              <el-select v-model="vinAccountForm.totalLedgerId">
                <el-option v-for="item in allshanghu" :key="item.id" :value="item.id"
                  :label="item.merchantName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="真实姓名" prop="trueName">
              <el-input v-model="vinAccountForm.trueName"></el-input>
            </el-form-item>
            <el-form-item label="收款银行" prop="bankName">
              <el-input v-model="vinAccountForm.bankName"></el-input>
            </el-form-item>
            <el-form-item label="收费类型" prop="type">
              <el-select v-model="vinAccountForm.type">
                <el-option v-for="item in typelist" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否主账户 -->
            <el-form-item label="登录账户" prop="userName">
              <el-input v-model="vinAccountForm.userName" :disabled="title !== '新增清分人'"></el-input>
            </el-form-item>
            <el-form-item label="商户名称" prop="merchantName">
              <el-input v-model="vinAccountForm.merchantName"></el-input>
            </el-form-item>
            <el-form-item label="主账户" prop="isMainAccount">
              <el-radio-group v-model="radio">
                <el-radio v-for="item in leaavel" :key="item.name" :label="item.name">{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属电站" prop="stationId">
              <el-select v-model="vinAccountForm.stationId" multiple>
                <el-option v-for="item in stationList" :key="item.id" :value="item.id"
                  :label="item.stationName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款卡号" prop="bankCard">
              <el-input v-model="vinAccountForm.bankCard"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="vinAccountForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="费率" prop="serviceRate">
              <el-input-number v-model="vinAccountForm.serviceRate" controls-position="right" :min="0"
                :max="100"></el-input-number>
              <span style="margin-left: 8px;">%</span>
            </el-form-item>
            <!-- 是否主账户 -->
            <el-form-item label="登录密码" prop="passWord">
              <el-input v-model="vinAccountForm.passWord"></el-input>
            </el-form-item>
            <el-form-item label="备注说明" prop="des">
              <el-input v-model="vinAccountForm.des"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogClosed">取 消</el-button>
        <el-button type="primary" v-debounce="editVinAccount" :disabled="btn1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 预约提现对话框 -->
    <el-dialog title="预约提现" :visible.sync="cashOutDialogVisible" width="38%" @close="cashOutDialogClosed"
      append-to-body>
      <el-form :model="settlementForm" :rules="settlementRules" ref="settlementRef" label-width="80px">
        <el-form-item label="账户余额" prop="money">
          <el-tag>￥{{ jisuan(settlementForm.money, 100, 2) }}</el-tag>
        </el-form-item>
        <el-form-item label="提现金额">
          <!-- 000 -->
          <el-input-number v-model="yuyuemoney" controls-position="right" @change="yuyueMethods"
            :step="0.01"></el-input-number>
          <span style="margin-left: 8px;">元</span>
        </el-form-item>
      </el-form>
      <el-radio v-model="settlementForm.contacts">个人银行卡</el-radio>
      <div style="margin: 15px 0;">
        <p>
          <b>拉卡拉收取</b> <span style="color: red;">0.6%</span>手续费
        </p>
        <p>
          <b>拉卡拉商户每笔提现金额额外收取</b> <span style="color: red;">￥1</span>手续费
        </p>
        <p>
          实际到账<span style="color: red;">￥{{ sjdz }}</span>
        </p>
      </div>
      <div style="margin: 15px 0;">
        <span style="font-weight: 700;">手续费规则：</span>
      </div>
      <div>
        <p>1.拉卡拉商户收取<span style="color:red">0.6%</span>的手续费</p>
        <p>2.拉卡拉商户每笔提现收取<span style="color:red">￥1</span>的手续费</p>
        <p>3.提现实时到账</p>
      </div>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="cashOutDialogClosed">取 消</el-button>
        <el-button type="primary" v-debounce="editCashOut" :disabled="yuyue">预约</el-button>
      </span>
    </el-dialog>
    <!-- 入账、提现明细弹窗 -->
    <el-dialog :title="startRcord == 1 ? '导出入账明细' : '导出出账明细'" :visible.sync="OrderLoag" width="30%" @close="qx_dialoag">
      <div class="cen">
        <el-date-picker v-model="value1" type="daterange" :picker-options="pickerOptions" range-separator="至"
          @blur="pickBlur" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
          @change="data_change">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qx_dialoag">取 消</el-button>
        <el-button type="primary" @click="chuMethods">
          <i class="el-icon-loading" v-if="loading"></i>
          <span>确 定</span>
        </el-button>
      </span>
    </el-dialog>
    <!-- 用户提现信息 -->
    <el-dialog title="用户信息" :visible.sync="userDialoag" width="30%" @close="userFalseMethods">
      <div class="pop2">
        <div class="h4">{{ listobj.merchantName }}</div>
        <ul>
          <li>
            <span>提现类型：</span><b>{{ listobj.acctType == 0 ? '对公' : '对私' }}</b>
          </li>
          <li>
            <span>提现账号：</span><b>{{ listobj.bankCard }}</b>
          </li>
          <li>
            <span>提现银行：</span><b>{{ listobj.bankName }}</b>
          </li>
          <li>
            <span>用户手机号：</span><b>{{ listobj.phone }}</b>
          </li>
          <li>
            <span>用户真实姓名：</span><b>{{ listobj.trueName }}</b>
          </li>
          <li>
            <span>用户创建时间：</span><b>{{ listobj.createTime }}</b>
          </li>
          <li>
            <span>用户场站：</span><b>{{ stationName }}</b>
          </li>
        </ul>
      </div>
    </el-dialog>

    <!-- 导出 -->
    <el-dialog title="导出" :visible.sync="daochuDialoag" width="30%" @close="closeMethods">
      <el-form :model="formobj" ref="formobjRef" label-width="80px">
        <el-form-item label="类型" prop="type">
          <!-- 0=提现,1=入账,2=补差3,提现失败,不传此参数表示全部 -->
          <el-select v-model="formobj.type">
            <el-option v-for="item in formtypelist" :key="item"
              :label="item == 0 ? '提现' : item == 1 ? '入账' : item == 2 ? '补差' : item == 3 ? '提现失败' : '全部'"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择时间">
          <el-date-picker type="datetimerange" @blur="pickBlur2" :picker-options="pickerOptions2" v-model="values"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" @change="changeTime2">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMethods">取 消</el-button>
        <el-button type="primary" @click="daochuMethods">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import caozuo from "@/utils/pubilc.js";
import { saveBlobToFile } from '@/utils/saveBlobToFile';
export default {
  name: 'Withdrawal',
  data() {
    return {
      userDialoag: false,
      stationName: '',
      embeddedUrl: '',
      tixianDialoag: false,
      mingxiTotal: 0,
      mingxiInfo: {
        stationLedgerId: null,
        page: 1,
        limit: 8
      },
      ruzhangList: [],
      ruzhang1Dialoag: false,
      title1: '',
      suoshudianzhan: '',
      yuyue: false,
      minMoney: 10,
      values: ['', ''],
      formtypelist: [0, 1, 2, 3, 4],
      startRcord: 0,
      pickerMinDate: '',
      pickerMinDate2: '',
      daochuDialoag: false,
      pickerOptions: {
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime()
          const start = this.formatDate(obj.minDate, 'start')
          const end = this.formatDate(obj.maxDate, 'end')
          obj.maxDate && (this.value1 = [start, end])
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const oneMonth = 1000 * 3600 * 24 * 31
            const maxTime = this.pickerMinDate + oneMonth
            const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
            const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
            return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
          }
        }
      },
      pickerOptions2: {
        onPick: obj => {
          this.pickerMinDate2 = new Date(obj.minDate).getTime()
          const start = this.formatDate(obj.minDate, 'start')
          const end = this.formatDate(obj.maxDate, 'end')
          obj.maxDate && (this.value1 = [start, end])
        },
        disabledDate: time => {
          if (this.pickerMinDate2) {
            const oneMonth = 1000 * 3600 * 24 * 31
            const maxTime = this.pickerMinDate2 + oneMonth
            const mixTime = this.pickerMinDate2 - oneMonth + 1000 * 3600 * 24
            const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
            return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
          }
        }
      },
      chaoguan: false,
      formobj: {
        stationLedgerId: null,
        type: 0,
        startTime: null,
        endTime: null,
      },
      expendTotal: 0,
      rzType: false,
      czType: false,
      zhangdanInfo: {
        stationLedgerId: null,
        page: 1,
        limit: 8
      },
      expendList: [],
      expendDialogVisible: false,
      bianji: false,
      yuyuetixian: false,
      wxsq: 0,
      sjdz: 0,
      num: 10,
      // 000
      yuyuemoney: 10,
      cashOutDialogVisible: false,
      settlementForm: {
        adminId: '',
        type: 0,
        trueName: '',
        bankCode: '',
        bankName: '',
        openId: '',
        status: 0,
        wechatId: '',
        phone: '',
        bankCard: '',
        serviceRate: '',
        powerStationId: 0,
        stationIds: '',
        money: 0,
        type: 0,
        des: '',
        merchantName: '',
      },
      settlementRules: {
        merchantName: [
          { required: true, message: '请至少选择一项', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择你的收费类型', trigger: 'change' }
        ],
        adminId: [
          { required: true, message: '请输入商户名称', trigger: 'change' }
        ],
        trueName: [
          { required: true, message: '真实姓名不能为空', trigger: 'blur' },
        ],
        bankName: [
          { required: true, message: '银行名称不能为空', trigger: 'blur' }
        ],
        openId: [
          { required: true, message: '收款openId不能为空', trigger: 'blur' }
        ],
        wechatId: [
          { required: true, message: '请至少选择一项', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '电话号码不能为空', trigger: 'blur' },
        ],
        bankCard: [
          { required: true, message: '银行卡号不能为空', trigger: 'blur' },
        ],
        serviceRate: [
          { required: true, message: '费率不能为空', trigger: 'blur' },
        ]
      },
      stationIds: '',
      ds: '',
      allshanghu: [],
      stationList: [],
      typelist: [{
        id: 0,
        name: '服务费'
      },
      {
        id: 1,
        name: '全额消费'
      },
      {
        id: 2,
        name: '全额电费'
      }],
      radio: '是',
      leaavel: [
        {
          name: '是'
        },
        {
          name: '否'
        }
      ],
      title: '',
      vinAccountFormRules: {
        trueName: {
          required: true, message: '请输入真实姓名', trigger: 'blur'
        },
        merchantName: {
          required: true, message: '请输入商户名称', trigger: 'blur'
        },
        type: {
          required: true, message: '请选择收费类型', trigger: 'change'
        },
        serviceRate: {
          required: true, message: '请输入或选择费率', trigger: 'blur'
        },
        phone: {
          required: true, message: '请输入联系电话', trigger: 'blur'
        },
        adminId: {
          required: true, message: '请选择提现商户', trigger: 'change'
        },
        // stationId: {
        //   required: true, message: '请选择所属电站', trigger: 'change'
        // },
        bankCard: {
          required: true, message: '请输入收款卡号', trigger: 'blur'
        },
        bankName: {
          required: true, message: '请输入收款银行', trigger: 'blur'
        },
        userName: {
          required: true, message: '请输入登录账户', trigger: 'blur'
        },
        passWord: {
          required: true, message: '请输入登录密码', trigger: 'blur'
        }
      },
      vinAccountForm: {
        passWord: '',
        userName: '',
        adminId: '',
        trueName: '',
        id: '',
        bankCard: '',
        bankName: '',
        type: 0,
        serviceRate: 0,
        des: '',
        isMainAccount: '1',
        freezeMoney: '',
        totalLedgerId: '',
        stationId: '',
        status: 0,
        merchantMame: ''
      },
      editDialogVisible: false,
      coolDialoag: false,
      //提现
      typeobj: {

      },
      freezeMoney: '',
      name: '人工转账',
      total2: 0,
      checkIndex: 0,
      btn1: false,
      // 明细表
      carinfo: {
        page: 1,
        limit: 8,
        stationLedgerId: '',
        roleId: window.sessionStorage.getItem('roleId'),
        type: 3
      },
      listname: [],
      title: '本月清分入账明细',
      titleDialoag2: false,
      suoshudianzhan: '',
      powerStationList: [],
      leaavelz: [
        '人工转账', '自动转账'
      ],
      ListTil: [],
      stopMoney: false,
      currentobj: {
        money1: 0,
        money2: 0
      },
      tabList: [],
      listobj: {},
      queryInfo: {
        page: 1,
        limit: 6,
        adminId: window.sessionStorage.getItem('adminId'),
        roleId: window.sessionStorage.getItem('roleId'),
        merchantName: ''
      },
      tilobj: {
        page: 1,
        limit: 150,
        adminId: window.sessionStorage.getItem('adminId'),
        roleId: window.sessionStorage.getItem('roleId'),
        merchantName: ''
      },
      obj: {

      },
      value1: ['', ''],
      OrderLoag: false,
      loading: false,
      total: 0,
      startTime: '',
      endTime: '',
      status: true
    }
  },
  computed: {
    shiji() {
      return function (abc, bac) {
        return (((abc * 1) + (bac * 1)) / 100).toFixed(2)
      }
    },
    wait_s() {
      return function (e) {
        return ((e.money - e.giveMoney) / 100).toFixed(2)
      }
    },
    time_all() {
      return function (val) {
        const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
        return hr
      }
    },
    jisuan() {
      return function (obj, num, fixed) {
        if (obj == null || obj == undefined) return '--';
        return (obj / num).toFixed(fixed)
      }
    },
    shifu() {
      return function (val) {
        return ((val.billMoney - val.billMoneygive) / 100).toFixed(2)
      }
    },
    jis() {
      return function (obj1, obj2, num, fixed) {
        return ((obj1 - obj2) / num).toFixed(fixed)
      }
    }
  },
  created() {
    this.tilMethods();
    this.publist();
    const that = this;
    const objj = [1, 2, 3, 10];
    const roleId = window.sessionStorage.getItem('roleId');
    let acc = {
      roleId: window.sessionStorage.getItem('roleId'),
      stationIds: window.sessionStorage.getItem('stationIds'),
      stationMode: '0,1,2'
    }
    caozuo(100).then(res => {
      that.caozuoquanxian = res;
    });
    // 导出入账明细
    caozuo(216).then(res => {
      that.rzType = res;
    });
    //导出出账明细
    caozuo(217).then(res => {
      that.czType = res;
    });
    // 提现权限
    caozuo(187).then(res => {
      that.bianji = res;
    })
    // 冻结金额权限
    caozuo(188).then(res => {
      that.stopMoney = res;
    })
    that.getVinAccountList();
    that.stationList = [];

    if (objj[roleId]) {
      this.$delete(acc, 'stationIds')
    } else {
      this.queryInfo.stationIds = window.sessionStorage.getItem('stationIds')
    }
    that.$http.get('station-info/getAllStationInfoName', {
      params: acc
    }).then(resb => {
      if (resb.data.code > 0) return;
      that.stationList = resb.data.data;
    });
    this.wxsq = Number(this.yuyuemoney) * 0.006;
    this.sjdz = Number(this.yuyuemoney) - Number(this.wxsq) - 1;
  },
  mounted() {
    const roleName = window.sessionStorage.getItem('roleName');
    this.chaoguan = roleName == '管理员' || roleName == '商户';
    this.$http.get('sysConfig/getSysConfigBOById/91').then(res => {
      const valueName = JSON.parse(res.data.data.valueName);
      this.yuyuemoney = window.sessionStorage.getItem('开发模式') == 'PROD' ? valueName[0].paramValue : valueName[1].paramValue;
      this.minMoney = window.sessionStorage.getItem('开发模式') == 'PROD' ? valueName[0].paramValue : valueName[1].paramValue;
      // console.log(this.yuyuemoney, '873');
    })
  },
  methods: {
    userFalseMethods() {
      this.userDialoag = false;
    },
    UserMessage() {
      this.$http.get('station-info/getAllStationInfoName', {
        params: {
          roleId: window.sessionStorage.getItem('roleId'),
          stationIds: window.sessionStorage.getItem('stationIds'),
          page: 1,
          limit: 30
        }
      }).then(res => {
        this.stationName = res.data.data.map(item => item.stationName).join(',');
        console.log(this.stationName,this.listobj,1027);
        this.userDialoag = true;
      })
    },
    closeMethods3() {
      this.tixianDialoag = false;
    },
    // 定时提现
    moneyMethods() {
      const abc = window.sessionStorage.getItem('开发模式');
      const ace = {
        'PROD': 'https://dzlapi.rcdqiot.com/',
        'TEST': 'https://testdzlapi.cpolar.top/',
      }
      this.embeddedUrl = ace[abc] + 'edit.html?uuid=' + this.listobj.autoWithdrawalMoney;
      this.tixianDialoag = true;
      console.log(this.embeddedUrl, 675)
    },
    ruzhang1Methods() {
      this.ruzhang1Dialoag = false;
      this.title1 = '';
      this.mingxiInfo = {
        page: 1,
        limit: 8
      }
    },
    ruzhang1(el) {
      this.title1 = el == 0 ? '入账明细' : '提现明细';
      this.mingxiTil()
    },
    mingxiChange(newSize) {
      this.mingxiInfo.limit = newSize;
      this.mingxiTil()
    },
    mingxiCurrentChange(newPage) {
      this.mingxiInfo.page = newPage;
      this.mingxiInfo.limit = 8;
      this.mingxiTil()
    },
    mingxiTil() {
      const abc = {
        '入账明细': "financial-overview/getStationLedgerLog",
        '提现明细': "financial-overview/getWithdrawalLog"
      };
      this.$http.get(abc[this.title1], {
        params: {
          roleId: window.sessionStorage.getItem('roleId'),
          stationLedgerId: this.listobj.id,
          page: this.mingxiInfo.page,
          limit: this.mingxiInfo.limit,
          type: 2
        }
      }).then(res => {
        const { code, data, count } = res.data;
        this.mingxiTotal = count;
        this.ruzhangList = code > 0 ? [] : data;
        this.ruzhang1Dialoag = true;
      })
    },
    async publist() {
      const objj = [5, 11, 17, 18];
      const roleId = window.sessionStorage.getItem('roleId');
      if (objj[roleId]) {
        let obj = {
          adminId: this.queryInfo.adminId,
          roleId: window.sessionStorage.getItem('roleId'),
          page: 1,
          limit: 10
        };
        if (roleId !== 5) {
          obj.IsMainAccount = 0;
        }
        const { data: res } = await this.$http.get('financial-overview/getAllStationLedger', {
          params: obj
        });
        if (res.code !== 0) return;
        this.powerStationList = res.data;
        return;
      }
      const { data: res } = await this.$http.get('station-ledger/getAllStationLedger', { params: this.tilobj })
      if (res.code !== 0) return;
      this.powerStationList = res.data;
    },
    daochuMethods() {
      if (this.values[0] == '' || this.values[1] == '') return this.$message.error('请选择导出时间');
      window.alert('正在导出中，请稍后...')
      if (this.formobj.startTime != null && this.formobj.endTime != null) {
        this.$http.get('station-ledger-log/export', {
          responseType: 'blob',
          params: {
            stationLedgerId: this.suoshudianzhan,
            type: this.formobj.type,
            startTime: this.formobj.startTime,
            endTime: this.formobj.endTime
          }
        }).then(res => {
          if (res.headers['content-type']?.includes('application/json')) {
            this.$message.error('无符合条件的订单！');
          } else {
            saveBlobToFile(res.data, '清分人明细记录');
            this.$message.success('文件导出成功');
          }
        })
      } else {
        this.$message.error('请选择你要导出的类型与时间');
      }
    },
    pickBlur2() {
      this.pickerMinDate2 = ''
    },
    changeTime2(value) {
      if (value) {
        this.formobj.startTime = value[0];
        this.formobj.endTime = value[1];
        if (this.formobj.startTime == this.formobj.endTime) {
          this.$message.error('起始时间不得为同一天！');
          this.formobj.startTime = ''
          this.formobj.endTime = ''
        }
      } else {
        this.formobj.startTime = null
        this.formobj.endTime = null
        this.pickerMinDate2 = '';
      }
    },
    formatDate(datetime, type) {
      const time = new Date(datetime)
      const year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = (time.getDate()).toString().padStart(2, '0')
      return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
    },
    getDate() {
      const start = new Date()
      this.values[0] = this.formatDate(start.getTime() - 1000 * 3600 * 24 * 30, 'start')
      this.values[1] = this.formatDate(start.getTime(), 'end')
    },
    closeMethods() {
      this.daochuDialoag = false;
      this.values = ['', ''];
      this.formobj.type = 0;
      this.formobj.startTime = null;
      this.formobj.endTime = null;
    },
    OrderMethods() {
      if (this.suoshudianzhan == '' || this.suoshudianzhan == undefined || this.suoshudianzhan == null) return this.$message.error('请选择清分人');
      this.formobj.stationLedgerId = this.suoshudianzhan;
      this.daochuDialoag = true;
    },
    // 更新日期
    formatDate(datetime, type) {
      const time = new Date(datetime)
      const year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = (time.getDate()).toString().padStart(2, '0')
      return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
    },
    // 修改最小日期
    pickBlur() {
      this.pickerMinDate = ''
    },
    data_change(e) {
      if (e.length > 0) {
        this.startTime = e[0];
        this.endTime = e[1];
        if (this.startTime == this.endTime) {
          this.$message.error('起始时间不得为同一天！');
          this.startTime = ''
          this.endTime = ''
        }
      } else {
        this.startTime = '';
        this.endTime = '';
      }
      console.log(this.startTime, this.endTime, '804');
    },
    chu(e) {
      this.OrderLoag = true;
      this.startRcord = e;
    },
    qx_dialoag() {
      this.OrderLoag = false;
      this.value1 = ['', ''];
      this.startTime = '';
      this.endTime = '';
    },
    chuMethods() {
      const that = this;
      that.loading = true;
      if (that.value1[0] == '') return that.$message.error('请选择你的导出时间');
      that.$http({
        url: 'station-ledger-log/export',
        method: 'get',
        params: {
          type: that.startRcord,
          stationLedgerId: that.listobj.id,
          startTime: that.startTime + ' ' + '00:00:00',
          endTime: that.endTime + ' ' + '23:59:59'
        }, responseType: 'blob'
      }).then(res => {
        if (res.headers['content-type']?.includes('application/json')) {
          that.$message.error(that.startRcord == 1 ? '入账明细不存在' : '出账明细不存在');
          that.loading = false;
        } else {
          that.$message.success(that.startRcord == 1 ? '入账明细文件导出成功' : '出账明细文件导出成功');
          saveBlobToFile(res.data, that.startRcord == 1 ? '入账明细' : '出账明细');
          that.OrderLoag = false;
          that.value1 = ['', '']; that.loading = false; that.OrderLoag = false;
        }
      })
    },
    expendDialogClosed() {
      this.expendDialogVisible = false;
      this.zhangdanInfo.limit = 8;
      this.zhangdanInfo.page = 1;
      this.expendList = [];
    },
    agoMoney() {
      const that = this;
      that.defaultMethods();
      that.expendDialogVisible = true;
    },
    defaultMethods() {
      const that = this;
      that.$http.get(`station-ledger-log-old/getStationLedgerLog?stationLedgerId=${that.listobj.id * 1}&page=${that.zhangdanInfo.page}&limit=${that.zhangdanInfo.limit}`).then(res => {
        console.log(res.data.code, '730');
        if (res.data.code !== 0) return;
        that.expendList = res.data.data;
        that.expendTotal = res.data.count;
      })
    },
    zhangdanCurrentChange(newPage) {
      this.zhangdanInfo.page = newPage;
      this.defaultMethods()
    },
    zhangdanChange(newSize) {
      this.zhangdanInfo.limit = newSize;
      this.defaultMethods()
    },
    yuyueMethods(e) {
      if (e > this.settlementForm.money) {
        this.$message('提现金额不得大于余额');
      } else {
        this.wxsq = Number((this.yuyuemoney * 0.006).toFixed(2));
        this.sjdz = Number(this.yuyuemoney) - Number(this.wxsq).toFixed(2) - 1;
      }
    },
    // 预约提现对话框的关闭事件
    cashOutDialogClosed() {
      this.cashOutDialogVisible = false;
      this.yuyue = false;
      this.yuyuemoney = 1;
    },
    // 预约提现的方法
    async editCashOut() {
      // this.tixianMethods2();
      if (this.listobj.orWithdraw == 0) return this.tixianMethods2();
      this.$message.error('您的转账正在银行处理流程中。若长期未到账，请联系售后人员。');
    },
    tixianMethods2() {
      const that = this;
      let abc = null;
      abc = that.yuyuemoney;
      that.yuyue = true;
      if (that.yuyue == false) return;
      if ((that.yuyuemoney * 100).toFixed(0) > that.settlementForm.money) {
        that.$message.error('提现金额不得大于余额');
        that.yuyue = false;
        return;
      }
      if ((that.yuyuemoney * 100).toFixed(0) < 1000) {
        that.$message.error('提现金额不得小于10元');
        that.yuyue = false;
        return;
      }
      // that.$http.post(`lkl-ewalletBalanceQuery/ewalletBalanceQuery?payType=` + 6).then(res1 => {
      //   if (res1.data.code > 0) {
      //     that.cashOutDialogClosed();
      //     that.$message.error('异常，请联系工作人员！')
      //     return
      //   }
      // const objs = JSON.parse(res1.data.data);
      // let acn = (objs.respData.curBalance * 100).toFixed(0);
      // console.log(acn, objs.respData.curBalance, '1058');
      // if (acn < Number((abc * 100).toFixed(0)) || Number((abc * 100).toFixed(0)) < 1000) {
      //   that.$message.error('提现金额不得大于代付账户余额，代付账户余额不得小于10元');
      //   return
      // }
      that.$http.post('lkl-sdfPaidPay/pay', {
        id: that.listobj.id,
        money: Number((abc * 100).toFixed(0)),
        adminId: Number(window.sessionStorage.getItem('adminId')),
        type: 0,
        terminal: 0
      }).then(res => {
        const res1 = res.data;
        switch (res1.code) {
          case 0:
            that.yuyue = false;
            that.cashOutDialogClosed();
            that.$message.success('提现成功，请注意银行信息!');
            that.getVinAccountList();
            // that.$http.post('lkl-sdfPaidPay/queryPay', {
            //   outTradeNo: res1.data.outTradeNo
            // }).then(ress => {
            //   const res2 = ress.data;that.cashOutDialogClosed();
            //   that.$message({ type: res2.code == 0 ? 'success' : 'error', message: res2.code > 0 ? '余额异常，请联系后台工作人员' : '提现成功，请注意银行信息！' });
            //   setTimeout(() => {
            //   }, 5000);
            // })
            break;
          default:
            if (res1.msg == '请求响应失败：{"code":"OP90001","msg":"请求服务失败【无访问权限(API无访问权限,请联系相关人员开通)】"}') return that.$message.error('账户提现异常，请联系后台工作人员!');
            that.$http.get('financial-overview/getAllStationLedger', { params: that.queryInfo }).then(res2 => {
              const ress = res2.data.data[0];
              that.cashOutDialogClosed();
              if (ress.orWithdraw == 1) {
                that.$message.error('实时到账，若2小时内未到账，可联系售后协助');
              } else {
                setTimeout(() => {
                  that.yuyue = false
                }, 5000);
                that.getVinAccountList();
              }
            })
            break;
        }
      })
      // })
    },
    changeMethods(el) {
      this.vinAccountForm = el;
      this.$http.post('station-ledger/updStationLedger', this.vinAccountForm).then(res => {
        this.$message.success('状态更新成功');
        this.freezeMoney = '';
        this.editDialogVisible = false;
        this.getVinAccountList(); this.publicMethods();
      })
    },
    // 添加&编辑清分人事件
    async editVinAccount() {
      const that = this;
      that.vinAccountForm.status = that.vinAccountForm.status == true || that.vinAccountForm.status == 0 ? 0 : that.vinAccountForm.status == false || that.vinAccountForm.status == 1 ? 1 : null;
      console.log(that.vinAccountForm.status, '1082');
      if (that.vinAccountForm.trueName == '') return that.$message.error('请输入真实姓名');
      if (that.vinAccountForm.bankCard == '') return that.$message.error('请输入收款卡号');
      if (that.vinAccountForm.bankName == '') return that.$message.error('请输入收款银行');
      if (that.vinAccountForm.phone == '') return that.$message.error('请输入联系电话');
      if (that.vinAccountForm.trueName == '') return that.$message.error('请输入真实姓名');
      if (that.vinAccountForm.password == '') return that.$message.error('请输入登录密码');
      if (that.vinAccountForm.stationId == '') return that.$message.error('请选择所属电站');
      if (that.vinAccountForm.totalLedgerId == '') return that.$message.error('请选择提现商户');
      let abc = that.vinAccountForm.stationId;
      that.vinAccountForm.stationId = typeof (abc) == 'Array' ? abc.map(item => item).join(',') : abc[0];
      const { data: res } = await that.$http.post('station-ledger/updStationLedger', that.vinAccountForm)
      that.btn1 = res.code !== 0 ? true : false;
      if (res.code !== 0) return that.$message.error(res.msg)
      that.$message.success('编辑清分人成功');
      that.freezeMoney = '';
      that.getVinAccountList();
      that.editDialogVisible = false;
      that.publicMethods()

    },
    // 用户详情
    editDialogClosed() {
      this.editDialogVisible = false;
    },
    // 确定冻结
    okMethods() {
      const that = this;
      if (that.freezeMoney == '' || that.freezeMoney == undefined || that.freezeMoney == null || that.freezeMoney == 0) return that.$message.error(`${that.freezeMoney == 0 ? '冻结金额应为整数且大于0' : '请检查您的冻结金额格式'}`);
      that.vinAccountForm.freezeMoney = that.freezeMoney * 100,
        that.$http.post('station-ledger/updStationLedger', that.vinAccountForm).then(res => {
          that.$message({
            type: res.data.code !== 0 ? 'error' : 'success',
            message: res.data.code !== 0 ? '冻结失败，请检查您的冻结金额' : '冻结金额设置成功'
          });
          if (res.data.code !== 0) return;
          that.getVinAccountList()
        })
    },
    // 确定取消
    falseMethods() {
      this.coolDialoag = false;
    },
    // 提现
    tixianMethods() {
      if (this.listobj.money == 0 || Number(this.listobj.money) < (this.yuyuemoney * 100).toFixed(0)) return this.$message.error('该账户余额不足，不支持提现');
      if (this.listobj.orWithdraw == 0) return this.codeMoney();
      this.$message.error('您的转账正在银行处理流程中。若长期未到账，请联系售后人员。');
    },
    codeMoney() {
      // this.$http.post(`lkl-ewalletBalanceQuery/ewalletBalanceQuery?payType=` + 6).then(res1 => {
      //   if (res1.data.code > 0) return console.error('异常，请联系工作人员！');
      // const objs = JSON.parse(res1.data.data);
      // console.log(objs, '1151');
      // let acn = (objs.respData.curBalance * 100).toFixed(0);
      // console.log(acn, objs.respData.curBalance, '1058');
      // if (acn < Number((this.yuyuemoney * 100).toFixed(0)) || Number((acn * 100).toFixed(0)) < 1000) return this.$message.error('提现金额不得大于代付账户余额，代付账户余额不得小于10元');
      this.cashOutDialogVisible = true;
      this.settlementForm.money = this.listobj.money;
      // })
    },
    // 关闭明细弹窗表
    colseDialoag2() {
      this.titleDialoag2 = false;
      this.carinfo.limit = 8;
      this.carinfo.page = 1;
    },
    // 编辑
    editMethods(row) {
      const that = this;
      that.powerStationOptions = [];
      that.allshanghu = [];
      that.vinAccountForm = {};
      that.editDialogVisible = true;
      that.$http.get('station-total-ledger/getAllStationTotalLedger', {
        params: {
          adminId: window.sessionStorage.getItem('adminId'),
          page: 1,
          limit: 100,
          id: null
        }
      }).then(res => {
        if (res.data.code !== 0) return;
        that.allshanghu = res.data.data;
      });
      that.$http.get(`station-ledger/getStationLedgerById/${row.id}`).then(res => {
        that.vinAccountForm = res.data.data;
        console.log(that.vinAccountForm, '1207')
        if (res.data.data.stationId.includes(',')) {
          that.vinAccountForm.stationId = that.vinAccountForm.stationId.split(',').map(item => Number(item))
        } else {
          that.vinAccountForm.stationId = [that.vinAccountForm.stationId * 1];
        }
        that.vinAccountForm.passWord = "******";
        that.radio = res.data.data.isMainAccount == 1 ? '是' : '否';
        // that.stationIds = that.vinAccountForm.stationIds * 1;
      });
    },
    // 提现明细
    mingxi(row) {
      const that = this; that.tabList = [];
      that.carinfo.stationLedgerId = row.id;
      that.listname = [];
      that.mingxiMethods()
    },
    mingxis(e) {
      const that = this;
      that.carinfo.type = e;
      that.listname = []; that.tabList = [];
      // that.carinfo.stationLedgerId = that.listobj.id;
      that.ds = e == 0 ? '本月' : '上月';
      that.mingxiMethods()
    },
    mingxiMethods() {
      const that = this;
      that.total2 = 0; that.tabList = [];
      that.title = "清分提现明细";
      that.$http.get('financial-overview/getWithdrawalLog', {
        params: this.carinfo
      }).then(res => {
        that.titleDialoag2 = true;
        if (res.data.code !== 0) return;
        that.tabList = res.data.data;
        that.total2 = res.data.count;
        that.listname = [
          {
            name: '提现总金额',
            money: that.tabList[0].withdrawalTotalMoney
          },
          {
            name: '本月提现总金额',
            money: that.tabList[0].withdrawalMonthTotalMoney
          },
          {
            name: '今日提现总金额',
            money: that.tabList[0].withdrawalToDayTotalMoney
          }
        ];
      });
    },
    // 冻结
    dongjie(row) {
      this.obj = row;
      this.vinAccountForm = row;
      this.coolDialoag = true;
    },
    // 入账明细(超管)
    ruzhang(row) {
      const that = this;
      that.listname = []; that.tabList = [];
      that.carinfo.stationLedgerId = row.id;
      that.ruzhangMethods()
    },
    // 入账明细（商户）
    ruzhangs(e) {
      const that = this; that.tabList = [];
      that.carinfo.type = e; that.listname = [];
      that.carinfo.stationLedgerId = that.listobj.id;
      that.ds = e == 0 ? '本月' : '上月';
      that.ruzhangMethods()
    },
    ruzhangMethods() {
      const that = this; that.title = "清分入账明细";
      that.tabList = [];
      that.$http.get('financial-overview/getStationLedgerLog', {
        params: that.carinfo
      }).then(res => {
        that.titleDialoag2 = true;
        that.total2 = res.data.count;
        if (res.data.code !== 0) return;
        that.tabList = res.data.data;
        that.listname = [
          {
            name: '入账总金额',
            money: res.data.data[0].postingTotalMoney
          },
          {
            name: '清分总金额',
            money: res.data.data[0].sortingTotalMoney
          },
          {
            name: '本月入账总金额',
            money: res.data.data[0].postingMonthTotalMoney
          },
          {
            name: '本月清分总金额',
            money: res.data.data[0].sortingMonthTotalMoney
          },
          {
            name: '今日入账总金额',
            money: res.data.data[0].postingToDayTotalMoney
          },
          {
            name: '今日清分总金额',
            money: res.data.data[0].sortingToDayTotalMoney
          }
        ]
      })
    },
    handleSizeChange2(newSize) {
      this.carinfo.limit = newSize;
      this.carinfo.page = 1;
      if (this.title == '清分提现明细') return this.mingxiMethods();
      this.ruzhangMethods()
    },
    handleCurrentChange2(newPage) {
      this.carinfo.page = newPage;
      if (this.title == '清分提现明细') return this.mingxiMethods();
      this.ruzhangMethods()
    },
    changeValue(e) {
      console.log(e, '664');
      if (e == '自动转账') return this.$message.error('正在开发中');
    },
    change_value(e) {
      console.log(this.powerStationList.filter(item => item.id === e)[0], '1385');
      this.queryInfo.merchantName = this.powerStationList.filter(item => item.id === e)[0].merchantName;
      this.publicMethods()
    },
    // defaultMethods() {
    //   const that = this;
    //   that.$http.get('financial-overview/getStationLedgerLog', {
    //     params: that.queryInfo
    //   }).then(res => {
    //     if (res.data.code !== 0) return;
    //     that.total = res.data.count;
    //     that.List = res.data.data;
    //   })
    // },
    async publicMethods() {
      const objj = [1, 2, 3, 10];
      if (!this.suoshudianzhan || this.suoshudianzhan === '') {
        this.$delete(this.queryInfo, 'merchantName');
      }
      const that = this;
      const roleId = window.sessionStorage.getItem('roleId');
      that.$http.get('financial-overview/getAllStationLedger', { params: that.queryInfo }).then(res => {
        that.total = res.data.count;
        if (res.data.code !== 0) return that.$message.error(res.data.msg);
        that.listobj = objj[roleId] ? {} : res.data.data[0];
        that.ListTil = !objj[roleId] || !res.data.data ? [] : res.data.data;
      })
    },
    async tilMethods() {
      this.$http.get('financial-overview/getAllStationLedger', { params: this.tilobj }).then(res => {
        this.total = res.data.count;
        this.powerStationList = !res.data.data || res.data.code > 0 ? [] : res.data.data;
        console.log(this.powerStationList, 1426)
      })
    },

    // 获取vin用户列表
    async getVinAccountList() {
      const that = this; const objj = [1, 2, 3, 10];
      const roleId = window.sessionStorage.getItem('roleId');
      await that.$http.get('financial-overview/getAllStationLedger', { params: that.queryInfo }).then(res => {
        that.total = res.data.count;
        if (res.data.code !== 0) return;
        that.listobj = objj[roleId] || !res.data.data ? {} : res.data.data[0];
        that.ListTil = !objj[roleId] || !res.data.data ? {} : res.data.data;
      })
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize;
      this.queryInfo.page = 1;
      this.getVinAccountList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage;
      this.getVinAccountList()
    }
  }
};
</script>

<style lang="less" scoped>
.embedded-frame {
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.centerList {
  height: 48vh;
}

.pop2 {
  height: auto;

  .h4 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  ul {
    margin: 0 10px;
    padding-bottom: 20px;

    li {
      line-height: 35px;
      font-size: 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;

      b {
        font-weight: bolder;
      }
    }
  }

}

.listnames {
  display: flex;
  flex-direction: row;
  height: 120px;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 20px;
  border: 1px solid gray;
  list-style: none;
  border-radius: 15px;

  .dl {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 20px;

    p {
      flex: 1;
      display: flex;
      justify-content: center;
      font-size: 18px;
    }

    p:nth-child(1) {
      color: gray;
      font-size: 16px;
    }

  }

  .dl:last-child {
    margin-right: 0;
  }
}

.Withdrawal {
  width: 97%;
  height: 100%;
  padding-bottom: 100px;
  margin: 0 2% 100px 1%;

  .cool {
    display: flex;
    flex-direction: column;

    p {
      display: flex;
      flex-direction: row;
      line-height: 20px;
    }

    p:nth-child(1) {
      align-items: center;

      span {
        margin-right: 10px;
      }
    }

    p:nth-child(2) {
      justify-content: center;
      align-items: center;
    }

    p:nth-child(5) {
      justify-content: center;

      button {
        width: 120px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        border: 1px solid #c5c5c5;
        font-size: 16px;
        border-radius: 5px;
        background: none;

      }

      button:nth-child(2) {
        margin-left: 20px;
        background: #13ce66;
        border: none;
        color: #fff;
      }
    }
  }

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -10px;

    h4 {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 16px;

      span {
        margin-right: 10px;
      }
    }
  }

  .center {
    width: 100%;
    height: 200px;

    h4 {
      height: 30px;
      display: flex;
      align-items: center;

      span {
        font-size: 18px;
      }
    }

    .ceil {
      height: 100%;
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        flex-direction: row;
        font-size: 18px;

        dl {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }

      li:nth-child(1) {
        flex: 4;
        margin-bottom: 10px;

        dl {
          height: 100%;

          dt,
          dd {
            flex: 1;
            display: flex;
            justify-content: center;
            // align-items: center;
          }

          dt {
            font-size: 24px;
            font-weight: bolder;
          }
        }

        dl:nth-child(5),
        dl:nth-child(4) {
          display: flex;
          justify-content: center;
          align-items: center;

          button {
            width: 120px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            background-color: blue;
          }
        }

        dl:nth-child(4) {
          dd {
            margin-left: -1%;
            color: blue;
          }
        }
      }

      li:nth-child(2) {
        flex: 6;
        border: 1px solid gray;
        border-radius: 15px;


        dt,
        dd {
          display: flex;
          justify-content: center;

        }

        dt {
          flex: 1;
          align-items: center;
        }

        dd {
          flex: 9;
          flex-direction: column;

          span {
            flex: 1;

            display: flex;
            justify-content: center;
            align-items: center;
          }

          span:nth-child(1) {
            padding: 10px 0;
          }
        }
      }
    }
  }
}
</style>